import React, { useState } from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import CopyIcon from '@mui/icons-material/ContentCopy';

export default function CopyableGridCell({ value }) {
  const [tooltip, setTooltip] = useState('Click to copy');
  const display_value =
    value === null || value === undefined ? '' : String(value);

  const copyText = (event) => {
    event.stopPropagation();
    if (!display_value) {
      return;
    }
    if ('clipboard' in navigator) {
      navigator.clipboard
        .writeText(display_value)
        .then(
          () => setTooltip('Copied!'),
          () => setTooltip('Copy Error!')
        );
    } else {
      setTooltip('Copy Error!');
    }
  };

  const resetTooltip = () => setTooltip('Click to copy');

  if (!display_value) {
    return null;
  }

  return (
    <Tooltip title={tooltip}>
      <Box
        onClick={copyText}
        onMouseLeave={resetTooltip}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          height: '100%',
          cursor: 'pointer',
          overflow: 'hidden',
          minWidth: 0,
        }}
      >
        <Typography
          variant='body2'
          component='span'
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            minWidth: 0,
          }}
        >
          {display_value}
        </Typography>
        <CopyIcon sx={{ fontSize: 14, flexShrink: 0, opacity: 0.6 }} />
      </Box>
    </Tooltip>
  );
}
